import AllocateToChannel from '../screens/InventoryAllocateAvailability/AllocateToChannel'
import AllocationHistoryDetails from '../screens/InventoryAllocateHistoryDetails'
import InventoryTabs from '../screens/InventoryTabs'
import { ROLE, RouteWithAccessType } from './types'

const inventoryPagesRoleManagement: RouteWithAccessType[] = [
  {
    route: '/inventory',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING,
      ROLE.PROVIDER_MARKETING,
      ROLE.TENANT_IT,
      ROLE.PROVIDER_IT,
      ROLE.ACCOMMODATION,
      ROLE.ACCOMMODATION_OPERATOR,
      ROLE.CHANNEL,
      ROLE.CHANNEL_ADMIN,
      ROLE.CHANNEL_ACTIVATION
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.ACCOMMODATION,
      ROLE.TENANT_MARKETING,
      ROLE.CHANNEL_ACTIVATION
    ],
    requiredFeatures: ['inventory.view', 'inventory.table.view'],
    component: <InventoryTabs />
  },
  {
    route: '/inventory/:page',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING,
      ROLE.PROVIDER_MARKETING,
      ROLE.TENANT_IT,
      ROLE.PROVIDER_IT,
      ROLE.ACCOMMODATION,
      ROLE.ACCOMMODATION_OPERATOR,
      ROLE.CHANNEL,
      ROLE.CHANNEL_ADMIN,
      ROLE.CHANNEL_ACTIVATION
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.ACCOMMODATION,
      ROLE.TENANT_MARKETING,
      ROLE.CHANNEL_ACTIVATION
    ],
    requiredFeatures: ['inventory.view', 'inventory.table.view'],
    component: <InventoryTabs />,
    sections: {
      SELECT_TENANT: {
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.CHANNEL_ACTIVATION
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN,
          ROLE.CHANNEL_ACTIVATION
        ]
        // requiredFeatures: ['inventory.view']
      },
      SELECT_ACCOMMODATION: {
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING,
          ROLE.PROVIDER_MARKETING,
          ROLE.TENANT_IT,
          ROLE.CHANNEL_ACTIVATION
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING,
          ROLE.PROVIDER_MARKETING,
          ROLE.TENANT_IT,
          ROLE.PROVIDER_IT,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN,
          ROLE.CHANNEL_ACTIVATION
        ]
        // requiredFeatures: ['inventory.view']
      },
      IS_TENANT: {
        rolesListWithReadAccess: [
          ROLE.TENANT,
          ROLE.TENANT_FINANCE,
          ROLE.TENANT_IT,
          ROLE.TENANT_MANAGEMENT,
          ROLE.TENANT_MARKETING,
          ROLE.TENANT_PR
        ],
        rolesListWithWriteAccess: [
          ROLE.TENANT,
          ROLE.TENANT_FINANCE,
          ROLE.TENANT_IT,
          ROLE.TENANT_MANAGEMENT,
          ROLE.TENANT_MARKETING,
          ROLE.TENANT_PR
        ]
        // requiredFeatures: ['inventory.view']
      },
      IS_ACCOMMODATION: {
        rolesListWithReadAccess: [
          ROLE.ACCOMMODATION,
          ROLE.ACCOMMODATION_OPERATOR
        ],
        rolesListWithWriteAccess: [
          ROLE.ACCOMMODATION,
          ROLE.ACCOMMODATION_OPERATOR
        ]
        // requiredFeatures: ['inventory.view']
      },
      IS_CHANNEL: {
        rolesListWithReadAccess: [
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN,
          ROLE.CHANNEL_ACTIVATION
        ],
        rolesListWithWriteAccess: [
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN,
          ROLE.CHANNEL_ACTIVATION
        ]
        // requiredFeatures: ['inventory.view']
      },
      IS_PROVIDER: {
        rolesListWithReadAccess: [ROLE.PROVIDER],
        rolesListWithWriteAccess: [ROLE.PROVIDER]
        // requiredFeatures: ['inventory.view']
      }
    },
    tabs: [
      {
        params: { page: 'table' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.ACCOMMODATION,
          ROLE.ACCOMMODATION_OPERATOR,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING,
          ROLE.CHANNEL_ACTIVATION
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_IT,
          ROLE.ACCOMMODATION,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING
        ],
        requiredFeatures: ['inventory.table.view']
      },
      {
        params: { page: 'allocate-availability' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.ACCOMMODATION,
          ROLE.ACCOMMODATION_OPERATOR,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.ACCOMMODATION,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING
        ],
        requiredFeatures: ['inventory.allocate.availability']
      },
      {
        params: { page: 'allocate-history' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.TENANT,
          ROLE.ACCOMMODATION,
          ROLE.TENANT_MARKETING
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.TENANT,
          ROLE.ACCOMMODATION,
          ROLE.TENANT_MARKETING,
          ROLE.CHANNEL_ACTIVATION
        ],
        requiredFeatures: ['inventory.allocate.history']
      },
      {
        params: { page: 'bulk-update' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.ACCOMMODATION,
          ROLE.ACCOMMODATION_OPERATOR,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING,
          ROLE.CHANNEL_ACTIVATION
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.ACCOMMODATION,
          ROLE.ACCOMMODATION_OPERATOR,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING,
          ROLE.CHANNEL_ACTIVATION
        ],
        requiredFeatures: ['inventory.bulk.update']
      },
      {
        params: { page: 'bulk-reset' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.ACCOMMODATION,
          ROLE.ACCOMMODATION_OPERATOR,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING,
          ROLE.CHANNEL_ACTIVATION
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.ACCOMMODATION,
          ROLE.ACCOMMODATION_OPERATOR,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING,
          ROLE.CHANNEL_ACTIVATION
        ],
        requiredFeatures: ['inventory.bulk.reset']
      }
    ]
  },
  {
    route: '/allocate-availability/allocate-to-channel',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.CHANNEL_ACTIVATION,
      ROLE.TENANT,
      ROLE.ACCOMMODATION,
      ROLE.ACCOMMODATION_OPERATOR,
      ROLE.TENANT_MARKETING,
      ROLE.PROVIDER_MARKETING,
      ROLE.TENANT_IT,
      ROLE.CHANNEL_ACTIVATION
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.ACCOMMODATION,
      ROLE.TENANT_MARKETING,
      ROLE.CHANNEL_ACTIVATION
    ],
    requiredFeatures: ['inventory.allocate.channel'],
    component: <AllocateToChannel />
  },
  {
    route: '/allocate-history/:requestID/details',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.CHANNEL_ACTIVATION,
      ROLE.TENANT,
      ROLE.ACCOMMODATION,
      ROLE.ACCOMMODATION_OPERATOR,
      ROLE.TENANT_MARKETING,
      ROLE.PROVIDER_MARKETING,
      ROLE.TENANT_IT,
      ROLE.CHANNEL_ACTIVATION
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.ACCOMMODATION,
      ROLE.TENANT_MARKETING,
      ROLE.CHANNEL_ACTIVATION
    ],
    requiredFeatures: ['inventory.allocate.details'],
    component: <AllocationHistoryDetails />
  }
]

export default inventoryPagesRoleManagement
